import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getDecisionNodeAtPath } from '../../../../extractFromState';
import { returnToPreviousMacroWizardPath } from 'actions/searchActions';
import DecisionTreeInfoWidget from '../../DTInfoWidget/DTInfoWidget';
import { BackButton } from 'components/common/buttonsComponents';
import Loading from '../../../LoadingComponent/LoadingComponent';
import {
  TopContainer,
  InfoWrapper,
  Container,
  BackButtonWrapper,
  ActionsButtonsWrapper,
  ImageDiv,
} from './DTQuestionOrInstruction.styles';

const DTQuestionOrInstructionView = ({ loading = false, titleSection, options, fullWidth = false }) => {
  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);

  const handleBackAction = () => {
    dispatch(returnToPreviousMacroWizardPath());
  };

  if (decisionNode) {
    if (loading) {
      return <Loading />;
    }

    return (
      <TopContainer>
        <InfoWrapper>{!!decisionNode.infoWidget && <DecisionTreeInfoWidget />}</InfoWrapper>
        <Container reduceTopPadding={!!decisionNode.infoWidget} fullWidth={fullWidth}>
          {titleSection}
          {decisionNode.image && <ImageDiv src={decisionNode.image} />}
          <ActionsButtonsWrapper>{options}</ActionsButtonsWrapper>
        </Container>
        <BackButtonWrapper key={'navigation'}>
          <BackButton onClick={handleBackAction}>BACK</BackButton>
        </BackButtonWrapper>
      </TopContainer>
    );
  }

  return null;
};

DTQuestionOrInstructionView.propTypes = {
  loading: PropTypes.bool.isRequired,
  titleSection: PropTypes.element.isRequired,
  options: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  fullWidth: PropTypes.bool,
};

export default DTQuestionOrInstructionView;
